<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
              h1.title Terminales&nbsp
                a.button.is-black.is-rounded.mr-3(@click="backPage" title="Regresar")
                  i.fas.fa-times
              .buttons.mt-3
                a.button.is-black.is-rounded.mr-3(@click="leerEstructuraDeCarpeta" title="Importar" v-if="this.permisos.permisos_sasisopa_id == 1")
                  i.fas.fa-cloud
                  p.mr-2.ml-2 Importar
                router-link.a.button.is-black.is-rounded.is-size-6(:to="`/SASISOPA/logs`" v-if="this.permisos.permisos_sasisopa_id == 1")
                  i.fas.fa-box
                  p.mr-2.ml-2 Registro de actividades
                router-link.a.button.is-black.is-rounded.is-size-6(:to="`/SASISOPA/solicitudes-cambio`" v-if="this.permisos.permisos_sasisopa_id == 1")
                  i.fas.fa-file
                  p.mr-2.ml-2 Solicitudes de cambio
                router-link.a.button.is-black.is-rounded.is-size-6(:to="`/SASISOPA/mis-solicitudes-cambio`" v-if="this.permisos.permisos_sasisopa_id != 1")
                  i.fas.fa-file
                  p.mr-2.ml-2 Mis solicitudes de cambio
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-3(v-for="(terminal, index) in terminals" :key="index")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse

                p.has-text-weight-medium.is-size-5 {{ terminal.name }}
                br
                .buttons.is-centered  <!-- Agrupa los botones -->
                  router-link.a.button.is-dark.is-rounded.is-size-6(:to="`/SASISOPA/documentos/${terminal.id}`")
                    | Entrar
                  router-link.a.button.is-black.is-rounded.is-size-6(:to="`/Apartado/SASISOPA/documentos/${terminal.id}/editar`" v-if="permisos.permisos_sasisopa_id == 1")
                    i.fas.fa-pen
                  a.button.is-danger.is-rounded.mr-1(@click="deleteItem(terminal.id)" title="Eliminar" v-if="permisos.permisos_sasisopa_id == 1")
                    i.fas.fa-trash



          .column.is-3(v-if="this.permisos.permisos_sasisopa_id == 1")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-plus.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Agregar terminal
                br
                .control
                  input.input.is-primary(
                    type='text',
                    placeholder='Nombre de la terminal',
                    v-model="terminal.name"
                  )
                br
                //- a.button.is-black.is-rounded(@click="fetchData")
                a.button.is-black.is-rounded.is-size-6(@click="checkForm()") Agregar
                //- router-link.a.button.is-black.is-rounded.is-size-6(to="/Apartado/SASISOPA/terminal") Agregar

            .modal.is-active(v-if="isModalActive")
              .modal-background.custom-background
              .modal-card
                header.modal-card-head
                  p.modal-card-title ¿Estás seguro de que deseas eliminar esta terminal?
                  button.modal-close.is-large(@click="closeModal")
                  button.button(@click="closeModal")
                    i.fas.fa-times
                section.modal-card-body.has-text-centered.strong
                  i.is-alert.is-large.fa.fa-exclamation.mb-2
                  br
                  br
                  strong Esta acción es irreversible y el CONTENIDO que se encuentra DENTRO DE LA CARPETA TAMBIEN SERÁ ELIMINADO.
                footer.modal-card-foot.has-text-right
                  .buttons
                    button.button.is-dark(@click="confirmDelete") Eliminar de todos modos
                    button.button.is-black(@click="closeModal") Cancelar

</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import { mapState } from 'vuex'
import sasisopaAPI from "@/services/axios_sasisopa.js";
import ModalAceptar from '@/components/turnos_Componentes/layout/ModalAceptar.vue';
import HeaderAccesos from '@/components/accesos_Componentes/layout/HeaderAccesos.vue';

export default {
  name: 'ApartadoSASISOPA',
  components: { Loader, NavBarCORP },
  data () {
    return {
      isLoading: false,
      terminals: [],
      isModalActive: false,
      terminalToDelete: null,
      terminal: {name: ""},
    }
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getTerminales();
        this.terminals = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    checkForm() {
      this.isLoading = true;
        this.datosFaltantes = [];
        if (this.terminal.name ) {
          this.guardarForm()
        } else {
          if (!this.terminal.name) {
            this.datosFaltantes.push('El nombre es requerido.')
          }
        }
    },
    async guardarForm() {
        try {
          const data = {
            name: this.terminal.name,
          };
          const response = await sasisopaAPI.postTerminal(data);
          this.terminal.name = "";
          this.fetchData();
          return response;
        } catch (error) {
          this.terminal.name = "";
          this.fetchData();
          this.datosFaltantes.push(error|| 'Error al guardar la terminal.');
          throw error;
        }
    },

    deleteItem(id) {
      this.terminalToDelete = id;
      this.isModalActive = true;
    },
    async confirmDelete() {
      if (this.terminalToDelete) {
        try {
          this.isLoading = true;
          await sasisopaAPI.DeleteTerminal(this.terminalToDelete);
          this.terminals = this.terminals.filter(terminal => terminal.id !== this.terminalToDelete);
        } catch (error) {
          console.error('Error al eliminar la terminal:', error);
          alert('Error al eliminar la terminal');
          this.fetchData();
        } finally {
          this.isLoading = false;
          this.isModalActive = false;
          this.terminalToDelete = null;
        }
      }
    },
    closeModal(){
      this.isModalActive = false;
    },
    backPage() {
      this.$router.back()
    },
    obtenerUser() {
    },
    async leerEstructuraDeCarpeta() {
      if (!window.showDirectoryPicker) {
        alert('EL NAVEGADOR NO ES COMPATIBLE CON ESTA FUNCIONALIDAD');
        return;
      }

      try {
        const carpeta = await window.showDirectoryPicker();

        if (false) {
        // if (!await this.verificarEstructura(carpeta)) {

          alert('Formato de la carpeta inválido');
          return;
        }
        const terminalData = { name: carpeta.name };
        const terminalResponse = await sasisopaAPI.postTerminal(terminalData);
        const terminalId = terminalResponse.data.id;

        await this.leerCarpeta(carpeta, terminalId);

        this.fetchData();
      } catch (error) {
        console.error("Error al leer la carpeta:", error);

      }
    },

    async verificarEstructura(carpeta) {
      const entradas = [];
      for await (const entrada of carpeta.values()) {
        entradas.push(entrada);
      }

      const tieneDocumentos = entradas.some(entrada => entrada.kind === 'directory' && entrada.name === 'Documentos');

      if (!tieneDocumentos) return false;

      const documentosFolder = entradas.find(entrada => entrada.name === 'Documentos');

      for await (const entrada of documentosFolder.values()) {
        if (entrada.kind === 'directory') {
          const ambitosFolder = entrada.getDirectoryHandle("Ambitos");
          if (!ambitosFolder) return false; // Falta la carpeta "Ambitos"

          // Verificar que no haya subcarpetas adicionales dentro de "Ambitos"
          const ambitosEntradas = [];
          for await (const ambito of ambitosFolder.values()) {
            ambitosEntradas.push(ambito);
          }
          if (ambitosEntradas.some(ambito => ambito.kind === 'directory' && ambito.name !== 'Archivos')) {
            return false; // Hay carpetas adicionales
          }
        }
      }
      return true; // Estructura válida
    },

    async leerCarpeta(carpeta, terminalId, nivel = 0) {
      const espacios = '  '.repeat(nivel);
      for await (const entrada of carpeta.values()) {
        if (entrada.kind === 'directory') {
          const docData = {
            name: entrada.name.split("-")[1],
            consecutive: entrada.name.split(".")[0],
            code: entrada.name.split(".")[1].split(" ")[0],
            terminal_id: terminalId
          };
          const Response = await sasisopaAPI.postDocument(docData);
          const responses = Response.split(/(?<=}\s*?)(?={)/);
          const parsedResponses = responses.map(res => {
              try {
                  return JSON.parse(res);
              } catch (error) {
                  console.error("Error al parsear JSON:", error);
                  return null;
              }
          });
          const docResponse = parsedResponses [0];

          const ambitosFolder = entrada;
          await this.leerAmbitos(ambitosFolder, docResponse.data.id);
        }
      }
    },

    async leerAmbitos(ambitosFolder, docId) {
      for await (const ambito of ambitosFolder.values()) {
        if (ambito.kind === 'directory') {
          const ambitoData = {
            name: ambito.name.split("-")[1],
            consecutive: ambito.name.split(".")[0],
            code: ambito.name.split(".")[1].split(" ")[0],
            document_id: docId
          };
          const Response = await sasisopaAPI.postAmbit(ambitoData);
          const responses = Response.split(/(?<=}\s*?)(?={)/);
          const parsedResponses = responses.map(res => {
              try {
                  return JSON.parse(res);
              } catch (error) {
                  console.error("Error al parsear JSON:", error);
                  return null;
              }
          });
          const ambitoResponse = parsedResponses [1];
          const archivosFolder = ambito;
          await this.leerArchivos(archivosFolder, ambitoResponse.data.id);
        }
      }
    },

    async leerArchivos(archivosFolder, ambitoId) {
      for await (const archivo of archivosFolder.values()) {
        if (archivo.kind === 'file') {
          const fileData = {
            name: archivo.name,
            id: ambitoId,
            file: await archivo.getFile()
          };
          console.log(fileData);
          try {
            const response = await sasisopaAPI.postFiles(fileData);
          } catch (error) {
            console.error(`Error al guardar el archivo ${archivo.name}:`, error);
          }
        }
      }
    }
},

  created () {
    this.$store.commit('irEstaciones','CORP')
    this.obtenerUser()
    this.fetchData();
    this.isModalActive = false;
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }
  .custom-background {
  background-color: #0c0c0cc0;
}
.is-alert {
  color: rgb(245, 68, 68);
}

.modal-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fa-exclamation {
  font-size: 3rem;
}
</style>




// WEBPACK FOOTER //
// src/components/apartados/ApartadoSASISOPA.vue